import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  StorageAllocationOverviewResponse,
  StorageAllocationsForShipperParams,
} from 'src/apis/storage/types';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageServiceRoot: StorageServiceRootRequest;
  params: StorageAllocationsForShipperParams;
};

type ExecuteOptions = {
  url: string;
  params: StorageAllocationsForShipperParams;
};

export function useStorageAllocationsForShipper({
  storageServiceRoot,
  params,
}: HookOptions) {
  const storageAllocations = useAxios(
    (axios, baseConfig, { url, params }: ExecuteOptions) =>
      axios.request<StorageAllocationOverviewResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageServiceRoot.response) return;

    const allocationsLink =
      storageServiceRoot.response.data._links.getAllocationsOverviewForShipper!; // we are checking for the link in the parent component

    const url = urlTemplate.parse(allocationsLink.href).expand({});

    storageAllocations.execute({
      url,
      params,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageServiceRoot.response, params]);

  return storageAllocations;
}

export type StorageAllocationsForShipperRequest = ReturnType<
  typeof useStorageAllocationsForShipper
>;
